import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=3a05e605&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=3a05e605&lang=scss&scoped=true&"
import style1 from "./Player.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Player.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05e605",
  null
  
)

export default component.exports